import * as App from "@discovery/maestro";
import * as Logger from "@discovery/maestro-logging";
import { pageID } from "../../../common/src/adobe/events";
import { Fold, Lens } from "@discovery/prelude/lib/control/lens";
import * as M from "@discovery/prelude/lib/data/maybe";
import { pushPageEvent } from "@discovery/common-dplus/lib/adobe";
import { getPathname } from "@discovery/components-dplus/lib/utils/common";
import { formatAMPM } from "../../../components/src/utils/common";
import { userDetails } from "./user";
import { _Page2CustomAttribute, _Page2PageAttr, _PageTitle } from "./optics";
import { updateGlobalState } from "@discovery/common-dplus/lib/hooks";
// ###### Route logging
/**
 * Function to pick out the page and sport from route
 * This is then using the logger to send a proper ECS log
 * https://github.com/elastic/ecs
 */
const getDateMeta = (date) => ({
    time: formatAMPM(date),
    date: date.getDate(),
    dayOfWeek: date.toLocaleDateString("en-in", { weekday: "long" }),
});
export const routeLogger = (res) => {
    const pageM = Fold.preview(_Page2PageAttr, res);
    const pageTitleM = Fold.preview(_PageTitle, res);
    const pageTitle = M.fromMaybe(pageTitleM, "");
    const logM = M.liftM((page) => ({ page }), pageM);
    const brand = "discoveryplus";
    const platform = "web";
    const appType = "web";
    const language = "en";
    const timeStamp = getDateMeta(new Date());
    const timeStampForAdobe = timeStamp.time + "|" + timeStamp.dayOfWeek + "|" + timeStamp.date;
    const userId = M.fromMaybe(userDetails.idM, "");
    const currentLocation = M.fromMaybe(userDetails.location, "");
    const isLoggedIn = M.fromMaybe(userDetails.anonymousM, false);
    const userPackage = M.fromMaybe(userDetails.packagesM, [""]);
    const userType = userPackage[0];
    const isKidsPageM = Fold.preview(_Page2CustomAttribute, res);
    const isKidsPage = M.fromMaybe(isKidsPageM, false);
    updateGlobalState(Lens.prop("isKidsPage"))((_oldKidsPage) => isKidsPage);
    updateGlobalState(Lens.prop("pageTitle"))((_oldPageTitle) => pageTitle);
    return M.foldMapConst(({ page }) => {
        const pageId = page.id;
        const pageType = M.fromMaybe(page.nameM, pageID.pageInfo.pageType);
        const pageName1 = M.fromMaybe(page.titleM, pageID.pageInfo.pageType);
        const pageName2 = M.fromMaybe(page.nameM, pageID.pageInfo.pageType);
        const pageName = M.fromMaybe(M.alt(page.titleM, page.nameM), pageID.pageInfo.pageType);
        pushPageEvent(pageName1 === "" ? pageName2 : pageName, pageType, brand, pageId, platform, pageType, appType, language, timeStampForAdobe, userId, currentLocation, isLoggedIn, userType);
        return Logger.tap(() => ({
            message: "page loaded",
            page: {
                id: page.id,
                name: M.fromMaybe(page.nameM, pageID.pageInfo.pageType),
                url: getPathname(),
            },
        }), res);
    }, App.of(res), logM);
};
